import { setCookie } from '@cian/utils/lib/browser/cookie';
import { parseCookies } from '@cian/utils/lib/shared/cookie';

export function cookieHelper(cookieName: string) {
  if (document && document.cookie) {
    const parsedCookieObject = parseCookies(document.cookie);

    if (!parsedCookieObject[cookieName]) {
      const expires = new Date();
      expires.setMinutes(expires.getMinutes() + 15);

      setCookie(cookieName, '1', {
        expires,
        secure: false,
      });

      return true;
    }
  }

  return false;
}
